import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import api from '../lib/api';
import { toast } from 'sonner';

export const ResetPasswordDialog = ({ target, isSelf, onClose }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  const close = () => { setPassword(''); setConfirm(''); setShow(false); onClose(); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error('Konfirmasi password tidak sama'); return; }
    setSaving(true);
    try {
      await api.put(`/users/${target.id}/password`, { new_password: password });
      toast.success(isSelf || ['internal', 'operasional'].includes(target.role) ? 'Password berhasil diganti' : `Password ${target.name} diganti. User wajib menggantinya saat login berikutnya.`);
      close();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Gagal mengganti password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!target} onOpenChange={(open) => { if (!open) close(); }}>
      <DialogContent className="max-w-md" data-testid="reset-password-dialog">
        <DialogHeader>
          <DialogTitle>Ganti Password</DialogTitle>
          {target && <p className="text-sm text-slate-600">{target.name} — {target.email}</p>}
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="space-y-1">
            <Label>Password Baru</Label>
            <Input type={show ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password-new" />
          </div>
          <div className="space-y-1">
            <Label>Ulangi Password Baru</Label>
            <Input type={show ? 'text' : 'password'} value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-password-confirm" />
          </div>
          <label className="flex items-center gap-2 text-sm text-slate-600">
            <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} data-testid="reset-password-show" /> Tampilkan password
          </label>
          <p className="text-xs text-slate-500">
            Minimal 8 karakter, mengandung huruf besar dan angka.
            {!isSelf && !['internal', 'operasional'].includes(target?.role) && ' User akan diminta mengganti password ini sendiri saat login berikutnya.'}
          </p>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" onClick={close}>Batal</Button>
            <Button type="submit" className="bg-red-600 hover:bg-red-700" disabled={saving} data-testid="reset-password-save">
              {saving ? 'Menyimpan...' : 'Simpan Password'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
